import { Component, OnInit, ViewChild, Input, EventEmitter, Output } from '@angular/core';
import { ModalComponent } from '../../modal/modal.component';
import { TranslateService } from '@ngx-translate/core';
import { GroupsService } from 'core/services';
import { DateTime } from 'luxon';

@Component({
  selector: 'lms-change-group-modal',
  templateUrl: './change-group-modal.component.html',
  styleUrls: ['./change-group-modal.component.scss']
})
export class ChangeGroupModalComponent implements OnInit {
  @Input() group: any;
  @Input() total: any;

  @Output() onSelectGroup = new EventEmitter<any>();
  @ViewChild('modalGroupsSelector', { static: false }) public modalGroupsSelector: ModalComponent;
  public groupsList: any[] = [];
  public selectedGroup: string;
  formError: any;
  userRole: any;

  constructor(public translate: TranslateService, public groupsService: GroupsService) {}

  ngOnInit() {}

  openModal() {
    this.findValidGroupsToMoveLicense();
    this.modalGroupsSelector.open();
  }

  /*
    It will return a list with the groups to which the license can be move to. The rules to allow it are
    - Group belongs to the same client
    - Group is open (it has not ended yet)
    - Group and licenses belong to the same game
    - Group is not a bonus class
  */
  findValidGroupsToMoveLicense() {
    return this.groupsService
      .fetch({
        clientId: this.group.clientId,
        customizationId: this.group.customizationId,
        limit: 100
      })
      .then((groups) => {
        const options = [];
        for (const group of groups.docs) {
          const groupIsOpen = group.endDate ? DateTime.fromISO(group.endDate) > DateTime.local() : true;
          const groupSameGame = group.customizationId === this.group.customizationId;
          const isSameGroup = group.id === this.group.id;

          if (!group.hasBonus && groupIsOpen && groupSameGame && !isSameGroup) {
            options.push({ key: group.id, value: group.name });
          }
        }
        this.groupsList = options;
      })
      .catch((err) => console.error('error ', err));
  }

  selectGroup(key) {
    this.selectedGroup = key;
  }

  confirmGroup() {
    this.onSelectGroup.emit(this.selectedGroup);
    this.modalGroupsSelector.close();
  }
}
